export type UniquePieceItem = {
  slug: string;
  title: string;
  intro?: string;
  paragraphs1: string;
  paragraphs2?: string;
  paragraphs3?: string;
  paragraphs4?: string;
  mainImage: string;
  sideImages?: string[];
  photographer?: {
    name: string;
    url: string;
  };
  reverse?: boolean;
  date?: string;
};

export const uniquePieceData: UniquePieceItem[] = [
  {
    slug: "consume",
    title: "Burned",
    intro: "Brulé",
    paragraphs1:
      "Irrité par le vice, de nombreuses âmes cherchent désespérément à s'échapper de leur quotidien ou à faire de leur quotidien un chemin régit par l'argent, la violence, le sexe et la drogue. L'âme ne peut être nourrit que par des actes et des pensées, bonnes ou mauvaises, c'est à vous d'en assumer les conséquences.",
    paragraphs2:
      "Cette création de couleur blanche représente la pureté de l'âme. Celle-ci fut modifiée grâce à un chalumeau représentant le mal qui se consume en elle, où l'on peut d'ores et déjà y apercevoir un aspect monstrueux, qui est représenté par un espace au niveau du front représentant des cornes bestiales. Les œillets représentent la douleur que l'âme s'inflige afin de se protéger du mal qui l'a dévore. Mais les cordes représentent la conscience de ces péchés dans le seul but d'ouvrir les yeux sur le mal que nos actes engendrent.",
    paragraphs3:
      "Lorsque le malsain s'empare de l'âme, le corps ne peut qu'en ressentir du rejet.",
    paragraphs4: "",
    mainImage: "/images/uniquepiece/consume/1.jpg",
    sideImages: [
      "/images/uniquepiece/consume/2.jpg",
      "/images/uniquepiece/consume/3.jpg",
    ],
  },
  {
    slug: "espoir",
    title: "Espoir",
    intro:
      "희망 , l'espoir née par la création, non pas par la haine ni par le pouvoir.",
    paragraphs1:
      "La Corée, terre fracturée en deux par des idéologies politiques différentes, est une terre très riche par sa culture mais aussi par son paysage. Avec de nombreux villages traditionnels et de grandes métropoles, la population coréenne est entourée de montagnes, de lieux de cultes traditionnels exceptionnels ainsi que de grandes tours et de buildings.Séoul, 16ème ville la plus riche au monde, Mégalopole emblématique, où l'on peut déceler une certaine fracture sociale forte avec de nombreux quartiers très pauvres.",
    paragraphs2:
      "Si tu ne marches pas aujourd’hui demain tu devras courir, 오늘 걷지 않으면 내일은 뛰어야 한다",
    paragraphs3:
      "화이팅  'Fighting!'. Ce terme est toujours utilisé pour déclarer sa motivation à haute voix et l'a partager avec les autres. Peuple honorable, courageux et respectueux, les coréens ont cette réputation de travailler dur afin d'être le meilleur dans leur domaine. Malgré les difficultés qu'engendre la vie, ils ne cessent de se motiver afin de ne pas abandonner.",

    paragraphs4:
      "Cagoule faite à la machine à coudre avec du rembourrage en ouate pour donner du volume et de l'ampleur aux signes du hangeul. Les signes ont été créés grâce à des jeans sauvés, usagés afin de leur donner une seconde vie.",

    mainImage: "/images/uniquepiece/espoir/1.jpg",
    sideImages: [
      "/images/uniquepiece/espoir/2.jpg",
      "/images/uniquepiece/espoir/3.jpg",
    ],
  },
  {
    slug: "esprit",
    title: "Esprit d'enfance",
    intro:
      "L'objectif étant d'inviter le public dans un environnement où la magie et les fantômes existent seulement pour ceux qui y croient.",
    paragraphs1:
      "Inspiration tirée du dessin animé français Esprit fantômes crée en 2002 par Didier Julia et Valérie Hadida. Dans cette série on y retrouve Jaz, un policier qui résout d'innombrables enquêtes accompagné de sa petite amie journaliste, Lucie ainsi que les 3 petits fantômes espiègles et farceurs, Tobi, Désastre et Toc-Toc. Cette création est apparue dans le but de replonger notamment le public de la génération Y en enfance avec ces visuels puisés des chaînes de la TV française. Le matin de bonne heure ou bien le soir vers 17H00, il était possible de voyager dans ce monde lugubre et rempli de mystère qu'était cette série animée.",
    paragraphs2:
      "Ce qu'il faut comprendre, c'est qu'une cagoule ne représente pas le mal, ni le mauvais genre, c'est la manière dont elle est utilisée qui l'a rend mauvaise. Ces visuels ont été repris directement d'épisodes de la série disponible sur Amazon Prime. Chaque visuel a été reproduit à la main avec une aiguille ainsi que du fil à broder noir. De face, on retrouve le château des grands-parents humains où habitent les petits fantômes ainsi que des chauves-souris représentant l'une des caractéristiques de l'ambiance de l'effroi. Sur le profil droit de la cagoule, Toc-Toc, le fantôme simplet regardant au loin, le château de sa famille l'ayant recueilli.",

    paragraphs3:
      "Sur le côté gauche, on remarque le fantôme le plus malin des 3, Tobi, regardant en souriant le dernier camarade de cette fratrie. Au dos de cette création, inquiet et douteux, on peut y découvrir Désastre le plus peureux des fantômes.",

    paragraphs4:
      "J'ai voulu partager l'un des dessins animés qui m'a marqué durant mon enfance. Montrant que des êtres différents de prima bord néfastes et funestes ne sont pas obligatoirement mauvais.",

    mainImage: "/images/uniquepiece/esprit/1.png",
    sideImages: [
      "/images/uniquepiece/esprit/2.png",
      "/images/uniquepiece/esprit/3.jpg",
      "/images/uniquepiece/esprit/4.png",
    ],
  },
  {
    slug: "r3",
    title: "R3",
    intro: "RE-créer, RE-cycler, RE-naître",
    paragraphs1:
      "L'upcycling, est un terme anglais qui désigne le fait de recycler un objet usagé en le transformant pour lui donner une nouvelle vie ainsi qu'une nouvelle fonction. Avec 3 jeans différents, j'ai sélectionné et découpé des morceaux plus ou moins grand afin de recrée une cagoule avec une large vision pour les yeux.",

    mainImage: "/images/uniquepiece/jean/1.png",
    sideImages: [
      "/images/uniquepiece/jean/2.jpg",
      "/images/uniquepiece/jean/3.png",
      "/images/uniquepiece/jean/4.png",
    ],
    photographer: {
      name: "littlemoment____",
      url: "https://www.instagram.com/littlemoment____",
    },
  },
];
